<template>
	<div style="" id="idOP" ref="idOP">
	</div>
</template>

<script>

export default {
	name: 'ImgThumOP',
	components:{

	},
	props:['item', 'ty', 'clk', 'dty'],
	data () {
		return {
		}
	},
	mounted: function(){
		let el=this.$refs["idOP"];
		let that=this;

		if( this.ty==100 )
		{
			if( this.item.siEquityLevel==130 ) el.style["background"] = "url(../../static/images/vip_1.png)";
			if( this.item.siEquityLevel==131 ) el.style["background"] = "url(../../static/images/vip_2.png)";
			if( this.item.siEquityLevel==132 ) el.style["background"] = "url(../../static/images/vip_3.png)";

			el.style["background-size"] = "100% 100%";
		}
		if( this.ty==1 )    // 预览按钮
		{
			el.setAttribute("class", "OP1" );
			el.setAttribute("title", LangText("预览") );
			el.style["background"] = "url(../../static/images/eye3.png)";
			el.style["background-size"] = "100% 100%";
			el.onclick = function(){ if( that.clk ) that.clk( that.item ); };
		}
		if( this.ty==2 )    // 删除按钮
		{
			//console.log( this.login.custId, gPlatCustId, that.item.templateCustId );
			if( ( this.dty=="src" && this.login.custId == gPlatCustId && that.item.siCustId == 0 )       ||  // 平台用户且是共享资源
			    ( this.dty=="src" && this.login.custId == that.item.siCustId ) ||                            // 资源为当前客户所有
			    ( this.dty=="tla" && this.login.custId == gPlatCustId && that.item.templateCustId == 0 ) ||  // 平台用户且是共享模板
			    ( this.dty=="tla" && this.login.custId == that.item.templateCustId ) ||                      // 模板为当前客户所有
			    ( this.dty=="cas" && this.login.custId == gPlatCustId && that.item.casCustId == 0 )      ||  // 平台用户且是共享场景
			    ( this.dty=="cas" && this.login.custId == that.item.casCustId ))                             // 场景为当前客户所有
			//if( ( this.dty=="src" && that.item.siCustId == gPlatCustId ) ||  // 平台且未共享的资源
			//	( this.dty=="src" && gPlatCustId < that.item.siCustId ) ||        // 私有资源
			//	( this.dty=="tla" && that.item.templateCustId == gPlatCustId ) ||  // 平台且未共享的模板
			//	( this.dty=="tla" && gPlatCustId < that.item.templateCustId ) )   // 私有模板
			{
				el.setAttribute("class", "OP1" );
				el.setAttribute("title", LangText("删除") );
				el.style["background"] = "url(../../static/images/del_a.png)";
				el.style["background-size"] = "100% 100%";
				el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
			}
			else
			{
				el.setAttribute("class", "OP2" );
				el.style["background"] = "url(../../static/images/del_d.png)";
				el.style["background-size"] = "100% 100%";
			}
		}
		if( this.ty==3 )    // 权益等级按钮
		{
			if( this.dty=="src" && that.item.siCustId == gPlatCustId )
			{
				el.setAttribute("class", "OP1" );
				el.setAttribute("title", LangText("权益等级") );
				el.style["background"] = "url(../../static/images/op_lev_a.png)";
				el.style["background-size"] = "100% 100%";
				el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
			}
			else
			{
				el.setAttribute("class", "OP2" );
				el.style["background"] = "url(../../static/images/op_lev_d.png)";
				el.style["background-size"] = "100% 100%";
			}
		}
		if( this.ty==4 )    // 共享按钮
		{
			if( (this.dty=="src" && that.item.siCustId == gPlatCustId ) ||   // 平台且未共享的资源
				(this.dty=="cas" && that.item.casCustId == gPlatCustId ) ||  // 平台且未共享的场景
				(this.dty=="tla" && that.item.templateCustId == gPlatCustId && that.item.templatePublish == 181 ) )  // 平台且未共享且已发布的模板
			{
				el.setAttribute("class", "OP1" );
				el.setAttribute("title", LangText("共享") );
				el.style["background"] = "url(../../static/images/op_share_a.png)";
				el.style["background-size"] = "100% 100%";
				el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
			}
			else
			{
				el.setAttribute("class", "OP2" );
				el.style["background"] = "url(../../static/images/op_share_d.png)";
				el.style["background-size"] = "100% 100%";
			}
		}
		if( this.ty==5 )    // 发布按钮, 只有模板需要发布
		{
			if( this.item.templatePublish == 180 )    // 未发布的模板
			{
				el.setAttribute("class", "OP1" );
				el.setAttribute("title", LangText("发布") );
				el.style["background"] = "url(../../static/images/op_publ_a.png)";
				el.style["background-size"] = "100% 100%";

				el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
			}
			else  // 已发布的模板
			{
				el.setAttribute("class", "OP2" );
				el.style["background"] = "url(../../static/images/op_publ_d.png)";
				el.style["background-size"] = "100% 100%";
			}
		}
		if( this.ty==8 )    // 缩略图、名称更新按钮
		{
			if( this.item.templatePublish == 180 )    // 未发布的模板
			{
				el.setAttribute("class", "OP1" );
				el.setAttribute("title", LangText("缩略图") );
				el.style["background"] = "url(../../static/images/op_thum_a.png)";
				el.style["background-size"] = "100% 100%";

				el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
			}
			else  // 未发布的模板
			{
				el.setAttribute("class", "OP2" );
				el.style["background"] = "url(../../static/images/op_thum_d.png)";
				el.style["background-size"] = "100% 100%";
			}
		}
		if( this.ty==9 )    // 编辑按钮, 只有模板需要编辑
		{
			// 为方便查看, 模板列表允许进编辑组件, 在编辑组件控制保存按钮
			el.setAttribute("class", "OP1" );
			el.setAttribute("title", LangText("编辑") );
			el.style["background"] = "url(../../static/images/op_edit_a.png)";
			el.style["background-size"] = "100% 100%";
			el.onclick = function(){ if( that.clk ) that.clk( event, that.item ); };
		}

	},
	computed:{

	},
	methods:{

	}
}

</script>

<style scoped>

.OP1{ float:left; margin-left:3px; width:26px; height:26px; border:1px solid #47c2d0; cursor:pointer; }
.OP1:hover{ opacity:0.7; }

.OP2{ float:left; margin-left:3px; width:26px; height:26px; border:1px solid #c4c4c4; }

</style>



// WEBPACK FOOTER //
// ImgThumOP.vue?d924d892